import { Card, Col, List, Row, Tag } from "antd";
import { Typography } from "antd";

const { Text } = Typography;

const getRandom = (list) => {
  const index = Math.floor(Math.random() * list.length);
  return list[index];
};

const colors = ["processing", "magenta", "red", "volcano", "green", "orange"];

function SkillsOverview({ skills }) {
  return (
    <Card bordered>
      <Row>
        <Col span={12} style={{ padding: 3 }}>
          <List
            header={<Text strong>Hard Skills</Text>}
            bordered
            dataSource={[skills.hard_skills_keywords]}
            renderItem={(item) => (
              <List.Item
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                {item.map((skill, i) => (
                  <Tag style={{ margin: 2 }} key={i} color={getRandom(colors)}>
                    {skill}
                  </Tag>
                ))}
              </List.Item>
            )}
          />
        </Col>
        <Col span={12} style={{ padding: 3 }}>
          <List
            header={<Text strong>Soft Skills</Text>}
            bordered
            dataSource={[skills.soft_skills_keywords]}
            renderItem={(item) => (
              <List.Item>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  {item.map((skill, i) => (
                    <Tag
                      style={{ margin: 2 }}
                      key={i}
                      color={getRandom(colors)}
                    >
                      {skill}
                    </Tag>
                  ))}
                </div>
              </List.Item>
            )}
          />
        </Col>
      </Row>
    </Card>
  );
}

export default SkillsOverview;
